import styled from "styled-components";

export const StyledManageGrades = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StyledManageGradesContainer = styled.div<{
  $isDraggingOver: boolean;
}>`
  width: 100%;
`;
